module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/feature2@2x.2054632.jpg";